<template>
  <div>
    <log-table
      :datetime-range="datetimeRange"
      :columns="columns"
      :get-func="getFunc"
    ></log-table>
  </div>
</template>

<script>
import LogTable from './LogTable.vue'

export default {
  name: 'HardwareLogTable',
  components: {
    LogTable
  },
  props: {
    getFunc: {
      type: Function
    },
    datetimeRange: {
      type: Array
    },
    source: {
      type: String
    }
  },
  data () {
    return {
      columns: [
        {
          dataIndex: 'timestamp',
          title: '采集时间',
          width: 200,
          scopedSlots: {
            customRender: 'timestamp'
          }
        },
        {
          dataIndex: 'time_local',
          title: '本地时间',
          width: 200,
          scopedSlots: {
            customRender: 'timeLocal'
          }
        },
        {
          dataIndex: 'hostip',
          title: 'IP 地址',
          width: 160,
          key: 'hostip',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'hostip'
          }
        },
        {
          dataIndex: 'hostname',
          title: '主机名称',
          width: 160,
          key: 'hostname',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'hostname'
          }
        },
        {
          dataIndex: 'severity',
          title: '严重性',
          width: 90,
          key: 'severity',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'severity'
          }
        },
        {
          dataIndex: 'info',
          title: '详情',
          width: 360,
          key: 'info',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'info'
          }
        }
      ]
    }
  }
}
</script>
